const allSearchTypes = [
    { text: 'Substructure', value: 'SUBSTRUCTURE' },
    { text: 'Similarity', value: 'SIMILAR' },
    { text: 'Molecular Formula', value: 'FORMULA' },
    { text: 'Molecular Weight', value: 'MASS' },
    { text: 'Features', value: 'FEATURES' },
    { text: 'Hazard', value: 'HAZARD', feature: 'hazard' },
    { text: 'Advanced', value: 'ADVANCED' },
];
const similarityTypes = [
    { text: 'Tanimoto', value: 'tanimoto' },
    { text: 'Euclidean', value: 'euclid-sub' },
    { text: 'Tversky', value: 'tversky' },
];
const authorities = [
    { text: 'Authoritative', value: 'Authoritative' },
    { text: 'Screening', value: 'Screening' },
    { text: 'QSAR Model', value: 'QSAR Model' },
];
const massType = ['molecular-weight', 'most-abundant-mass', 'monoisotopic-mass'];
const toxicities = [
    { text: 'Very High', value: 'VH' },
    { text: 'High', value: 'H' },
    { text: 'Medium', value: 'M' },
    { text: 'Low', value: 'L' },
    { text: 'Any', value: 'A' },
];
const defaultSearchOptions = {
    searchType: 'SUBSTRUCTURE',
    minSimilarity: 0.85,
    maxNumOfStructures: null,
    minNumOfStructures: null,
    useSimilarity: false,
    fpType: 'bingo',
    similarityType: 'tanimoto',
    formula: null,
    queryFormula: true,
    minMass: null,
    maxMass: null,
    massSearchParamsValid: null,
    massType: 'monoisotopic-mass',
    singleComponent: true,
    features: [],
    includeElements: null,
    excludeElements: null,
    hazardNames: [],
    hazardSource: null,
    hazardRoute: null,
    hazardCategory: null,
    hazardCode: null,
    hazardOrganism: null,
    toxicity: null,
    authority: null,
};
const defaultPageOptions = {
    sortBy: 'similarity',
    sortDirection: 'desc',
    pageSize: 50,
    currentPage: 1,
};
const defaultFilterState = [
    {
        text: 'Stereo',
        value: 'filter-stereo',
        state: null,
        count: null,
        // next: true,
    },
    {
        text: 'Chiral',
        value: 'filter-chiral',
        state: null,
        count: null,
        // next: true,
    },
    {
        text: 'Isotopes',
        value: 'filter-isotopes',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Charged',
        value: 'filter-charged',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Multicomponent',
        value: 'filter-multicomponent',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Radicals',
        value: 'filter-radicals',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Salts',
        value: 'filter-salts',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Polymers',
        value: 'filter-polymers',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Sgroups',
        value: 'filter-sgroups',
        state: null,
        count: null,
        // next: false,
    },
    {
        text: 'Toxicity',
        value: 'filter-toxicity',
        state: null,
        count: null,
        // next: false,
    },
];
export { defaultSearchOptions, defaultPageOptions, defaultFilterState, allSearchTypes, similarityTypes, authorities, toxicities, massType, };
